import { apiClient } from './ApiClient';
import { API_ENDPOINTS } from '../../shared/constants';
import { ApiResponse, TransactionApiData } from '../../shared/types';

export class TransactionApi {
    static async fetchBySupplierId(supplierId: number, token: string): Promise<TransactionApiData[]> {
        try {
            const response = await apiClient.get<ApiResponse<TransactionApiData[]>>(
                API_ENDPOINTS.transactions(supplierId),
                token
            );

            if (!response.success || !response.data) {
                return [];
            }

            return response.data;
        } catch (error) {
            console.error('Error fetching transactions:', error);
            return [];
        }
    }
}

